function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.333 3.833h13.334a1.5 1.5 0 011.5 1.5v13.333a1.5 1.5 0 01-1.5 1.5H5.333a1.5 1.5 0 01-1.5-1.5V5.333a1.5 1.5 0 011.5-1.5zm0 1a.5.5 0 00-.5.5v13.333a.5.5 0 00.5.5h13.334a.5.5 0 00.5-.5V5.333a.5.5 0 00-.5-.5z"
});

function SvgCheckboxUnchecked(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "checkboxUnchecked.87cad.svg";
export { SvgCheckboxUnchecked as ReactComponent };